import { useState, useContext, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  toastSuccessMessage,
  InputValidationConstants,
  InputControl,
  Loading,
  getDefaultUser,
  LogotypeBelkaPoziom,
} from "wup-module1-base";
import { Form, Row, Col, Button } from "react-bootstrap";
import UserContext from "../../Contexts/UserContext";
import { useForm } from "react-hook-form";
import { AuthService } from "../../Services";
import "./Login.css";
import { toast } from "react-toastify";

function PasswordSet() {
  const { hash } = useParams();
  const setPasswordSuccessMessage = "Hasło zostało zapisane!";
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [userId, setUserId] = useState();
  const { user, setUser } = useContext(UserContext);
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
  });

  useEffect(() => {
    AuthService.checkLink(hash)
      .then((response) => {
        setUserId(response.data.clientId);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Link jest nieaktywny albo hasło zostało już ustawione!");
      });
  }, []);

  const logout = () => {
    AuthService.logout()
      .then((response) => {
        setUser(getDefaultUser());
        navigate("/login");
      })
      .catch((error) => {
        toast.error("Nie udało się ustawić hasła");
      })
      .finally(() => {
        sessionStorage.clear();
        localStorage.clear();
      });
  };

  const setPassword = (data) => {
    setIsSubmitting(true);

    const requestData = {
      clientId: userId,
      password: getValues("password"),
      password_confirmation: getValues("password_r"),
      hash: hash,
    };

    AuthService.setPassword(requestData, userId)
      .then((response) => {
        if (response) {
          setIsSubmitting(false);
          toastSuccessMessage("Hasło ustawione pomyślnie!");
          if (!!user.id) {
            logout();
          } else {
            navigate("/login");
          }
        }
      })
      .catch((error) => {
        console.error(error);
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors &&
          error.response.data.errors.password
        ) {
          let errorMessage = error.response.data.errors.password[0];
          let decodedErrorMessage = JSON.parse(`"${errorMessage}"`);
          toast.error(decodedErrorMessage);
        } else {
          toast.error(error.message || "Coś poszło nie tak");
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <>
      {userId ? (
        <Form onSubmit={handleSubmit(setPassword)}>
          <Row>
            <Col md={12} className="login-image-col">
              <img
                className="d-inline-block image-fluid login-image"
                src={LogotypeBelkaPoziom}
                alt="Logo MAŁOPOLSKA"
              />
            </Col>
            <Col md={12} className="login-header-col">
              <div className="login-header-text">
                <h1 className="login-header d-inline-block align-self-end mb-1">
                  Utworzenie hasła
                </h1>
              </div>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col md={6}>
              <InputControl
                id="password"
                label="Wpisz hasło"
                type="password"
                refs={{
                  ...register("password", {
                    required: InputValidationConstants.required,
                    validate: (value) => {
                      if (!value) {
                        return "To pole jest wymagane.";
                      }
                      const passwordRegex =
                        /^(?=.*[A-Z].*[A-Z])(?=.*[a-z].*[a-z])(?=.*[0-9].*[0-9])(?=.*[^a-zA-Z0-9]).{12,}$/;
                      if (!passwordRegex.test(value)) {
                        return "Hasło powinno składać się z przynajmniej 12 znaków w tym dwóch cyfr, jednego znaku specjalnego, dwóch małych oraz dwóch dużych liter.";
                      }

                      return null;
                    },
                  }),
                }}
                errors={errors}
              />
            </Col>
            <Col md={6}>
              <InputControl
                id="password_r"
                label="Powtórz hasło"
                type="password"
                refs={{
                  ...register("password_r", {
                    required: InputValidationConstants.required,
                    validate: (value) => {
                      if (!value) {
                        return "To pole jest wymagane.";
                      }
                      if (value !== getValues("password")) {
                        return "Hasła powinny być takie same.";
                      }

                      return null;
                    },
                  }),
                }}
                errors={errors}
              />
            </Col>
          </Row>
          <Row className="my-0">
            <Col className="text-right">
              <Button
                type="submit"
                variant="login-submit"
                disabled={isSubmitting}
                className="px-5"
              >
                {isSubmitting ? (
                  <Loading size="sm" className="p-0" variant="light" />
                ) : (
                  "Zatwierdź"
                )}
              </Button>
            </Col>
          </Row>
        </Form>
      ) : (
        <div>
          {" "}
          <Row>
            <Col md={12} className="login-image-col">
              <img
                className="d-inline-block image-fluid login-image"
                src={LogotypeBelkaPoziom}
                alt="Logo MAŁOPOLSKA"
              />
            </Col>
            <Col md={12} className="login-header-col">
              <div className="login-header-text">
                <h1 className="login-header d-inline-block align-self-end mb-1">
                  Utworzenie hasła
                </h1>
              </div>
            </Col>
          </Row>
          <Row>Link jest nieaktywny albo hasło zostało już ustawione!</Row>
        </div>
      )}
    </>
  );
}

export default PasswordSet;
